import { FC, useState } from 'react';
import { getFlagUrl } from "../../../../../_ftbl/main/helpers/getFlagUrl";
import WorldIcon from 'shared/icons/WorldIcon';
import { TeamFlagFallback, TeamFlagImage, TeamFlagWrapper } from './styles';

type ProfilePredictionFlagProps = {
  countryId: number;
};

export const ProfilePredictionFlag: FC<ProfilePredictionFlagProps> = ({ countryId }) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <TeamFlagWrapper>
        <TeamFlagFallback>
          <WorldIcon fill="#BBB" />
        </TeamFlagFallback>
      </TeamFlagWrapper>
    );
  }

  return (
    <TeamFlagWrapper>
      <TeamFlagImage
        src={getFlagUrl(countryId)}
        alt=""
        onError={() => setHasError(true)}
      />
    </TeamFlagWrapper>
  );
};
import { FC, useState } from 'react';
import { getFlagUrl } from "../../../../../_ftbl/main/helpers/getFlagUrl";
import WorldIcon from 'shared/icons/WorldIcon';
import { TeamFlagFallback, TeamFlagImage, TeamFlagWrapper } from './styles';

type ProfilePredictionFlagProps = {
  countryId: number;
};

export const ProfilePredictionFlag: FC<ProfilePredictionFlagProps> = ({ countryId }) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <TeamFlagWrapper>
        <TeamFlagFallback>
          <WorldIcon fill="#BBB" />
        </TeamFlagFallback>
      </TeamFlagWrapper>
    );
  }

  return (
    <TeamFlagWrapper>
      <TeamFlagImage
        src={getFlagUrl(countryId)}
        alt=""
        onError={() => setHasError(true)}
      />
    </TeamFlagWrapper>
  );
};
